export const badgeFrequency = [
  {value: "Blank", label: "Select Frequency"},
  {value: "Weekly", label: "Weekly"},
  {value: "Monthly", label: "Monthly"},
  {value: "Quarterly", label: "Quarterly"},
  {value: "Annually", label: "Annually"},
];
